import React from 'react';

// material
import {Button, Card, CardContent, Grid, withStyles} from '@material-ui/core';
import { Facebook, LinkedIn, Twitter, Instagram } from '@material-ui/icons';
//styles
import styles from './social-media-card-styles';

const SocialMediaCardView = (props)=> {
  const {
      classes, 
      isLoading,
      socialMedia
  } = props;

  return(
    <Card>
      <CardContent>
        <Grid container className={classes.displayTitle} spacing={2}>
          <Grid item>Social Media</Grid>
          <Grid item>
            <Button
                color={'primary'}
                size={'small'}
                variant={'contained'}
                onClick={() => props.toggleEdit()}>
                Edit
            </Button>
          </Grid>
        </Grid>
        {
          !isLoading &&          
          <Grid container className={classes.displayBody} spacing={2}>
            <Grid className={classes.textFieldSpacing} item>
              <Facebook fontSize={'large'} className={socialMedia.facebookProfileUrl === '' ? classes.inactiveButton : classes.facebookButton}/>
            </Grid>
            <Grid className={classes.textFieldSpacing} item>
              <LinkedIn fontSize={'large'} className={socialMedia.linkedInProfileUrl === '' ? classes.inactiveButton : classes.linkedInButton}/>
            </Grid>
            <Grid className={classes.textFieldSpacing} item>
                    <Twitter fontSize={'large'} className={socialMedia.twitterProfileUrl === '' ? classes.inactiveButton : classes.twitterButton}/>
            </Grid>
            <Grid className={classes.textFieldSpacing} item>
              <Instagram fontSize={'large'} className={socialMedia.instagramProfileUrl === '' ? classes.inactiveButton : classes.instagramButton}/>
            </Grid>
          </Grid>
        }
      </CardContent>
    </Card>
  )
};

export default withStyles(styles) (SocialMediaCardView);